import { render } from "./HomeAdmin.vue?vue&type=template&id=35e95127&scoped=true"
import script from "./HomeAdmin.vue?vue&type=script&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&lang=js"

import "./HomeAdmin.vue?vue&type=style&index=0&id=35e95127&scoped=true&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Gestion conge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e95127"]])

export default __exports__